// extracted by mini-css-extract-plugin
module.exports = {"backgroundLayer":"FollowCursor_backgroundLayer__n6gZu","backgroundFollower":"FollowCursor_backgroundFollower__pyMd4"};